import { render, staticRenderFns } from "./statusRastreio.vue?vue&type=template&id=fe7c2060&"
import script from "./statusRastreio.vue?vue&type=script&lang=js&"
export * from "./statusRastreio.vue?vue&type=script&lang=js&"
import style0 from "./statusRastreio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports